let _ = t => t,
  _t;
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error Library not yet migrated
import Carousel from './Carousel';
import FullWidthBackgroundColor from './TrackLessonOverviewModal/subcomponents/FullWidthBackgroundColor';
import SectionHeading from './SectionHeading';
// @ts-expect-error Library not yet migrated
import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import ACInstructorCard from 'academy-common-lib/components/card/ACInstructorCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BackgroundTile = styled(UITile).withConfig({
  displayName: "InstructorList__BackgroundTile",
  componentId: "sc-11h0o5g-0"
})(["border:none;border-radius:0;background-color:transparent;margin-top:0 !important;position:relative;"]);
export const ModalTileSection = styled(UITileSection).withConfig({
  displayName: "InstructorList__ModalTileSection",
  componentId: "sc-11h0o5g-1"
})(["", ""], mediaQuery('mobile', css(_t || (_t = _`
      padding-left: 12px;
      padding-right: 12px;
    `))));
const PlainWrapper = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  children: children
});
const InstructorList = ({
  professors,
  language,
  handleOrganisationUrlClick
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const ProfessorCardsLayout = isMobile || professors.length < 2 ? PlainWrapper : Carousel;
  return /*#__PURE__*/_jsxs(BackgroundTile, {
    children: [/*#__PURE__*/_jsx(FullWidthBackgroundColor, {
      $color: "GYPSUM"
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      className: "instructors-tile-section",
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        className: "p-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.instructorList.heading"
        })
      }), /*#__PURE__*/_jsx(ProfessorCardsLayout, {
        fixedMargin: true,
        pageMargin: isMobile ? 12 : 32,
        children: professors.map(professor => /*#__PURE__*/_jsx(ACInstructorCard, {
          description: professor.descriptions[language.toLowerCase()],
          imageUrl: professor.image,
          jobTitle: professor.jobTitle,
          name: professor.name,
          onClick: handleOrganisationUrlClick(professor.id.toString(), professor.organisation, professor.organisationUrl),
          organisationName: professor.organisation,
          organisationUrl: professor.organisationUrl,
          style: {
            maxWidth: !isMobile && professors.length && 'calc(min(850px, 100vw) * 0.8)' || undefined
          }
        }, professor.id))
      })]
    })]
  });
};
export default InstructorList;